import { useState } from 'react';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';

import { toast } from 'react-toastify';

import { ModalWindow } from '../../Components/ModalWindow';

export const SubscribeSection = () => {
  const schema = yup
    .object({
      email: yup.string().required('email is a required field').email('email is not valid'),
    })
    .required();
  const { register, handleSubmit, reset } = useForm({ resolver: yupResolver(schema) });

  const [isModalOpened, setOpenModal] = useState(false);
  const [email, setEmail] = useState('');

  const onSubmit = (data) => {
    setEmail(data.email);
    setOpenModal(true);
  };

  const sendEmail = () => {
    setOpenModal(false);
    reset();
    toast(`🧙wait for your acceptance letter at ${email}!`);
  };

  return (
    <section className="relative h-54em w-full">
      <div className="bg-cover bg-center bg-subSection bg-no-repeat absolute top-0 right-0 bottom-0 left-0">
        <div className="relative w-full h-full flex justify-center items-center">
          <div className="absolute top-0 right-0 bottom-0 left-0 z-10 bg-shadowDark"></div>
          <div className="flex flex-col items-center z-20">
            <h2 className="font-poppins font-normal text-whiteMagic text-xl md:text-3xl text-center leading-7 tracking-wider">
              Subscribe to our newsletter
            </h2>
            <form className="mt-4 flex flex-col smart:flex-row gap-6 items-center" onSubmit={handleSubmit(onSubmit)}>
              <div className="flex flex-col">
                <input
                  className="h-11 w-78 bg-transparent border border-borderColor rounded-3xl py-3 px-7 font-poppins font-normal text-base md:text-lg text-font placeholder:text-font placeholder:font-poppins placeholder:text-base md:placeholder:text-lg"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter email"
                  {...register('email', { required: true })}
                />
              </div>
              <button
                className="p-1 rounded-full h-10 w-28 flex justify-center items-center bg-gradient-to-r from-grStart to-grEnd font-poppins leading-5 border border-transparent text-font hover:bg-none duration-300 hover:border-borderColor"
                type="submit">
                Leviosa
              </button>
            </form>
          </div>
        </div>
      </div>
      {isModalOpened && (
        <ModalWindow closeModal={() => setOpenModal(false)}>
          <div className="mt-10 flex flex-col gap-5 justify-center items-center p-3 smart:p-5 ">
            <h2 className="font-crimson font-bold text-lg md:text-xl leading-6 flex tracking-wider text-center">
              Are you sure about your adress?
            </h2>
            <div className="flex gap-4 justify-center items-center">
              <button
                className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                onClick={sendEmail}>
                Yep
              </button>
              <button
                className="h-12 w-28 font-crimson font-normal text-lg leading-8 tracking-wider flex justify-center items-center duration-500 bg-transparent border-2 rounded-3xl border-borderColor hover:text-font hover:bg-borderColor"
                onClick={() => setOpenModal(false)}>
                Nope
              </button>
            </div>
          </div>
        </ModalWindow>
      )}
    </section>
  );
};
